<template>
  <div class="s-homepage__product-search">
    <ProductSearch
      :key="isLocationSearchEnabled ? 'location' : 'default'"
      :button-label="tr('client.homepage.product_search_looking_for_button')"
      :label="tr('client.homepage.product_search_looking_for_label')"
      :placeholder="tr('client.homepage.header_looking_for_placeholder')"
      prefix-icon="far fa-search"
      :resolve-target="isLocationSearchEnabled ? resolveTarget : undefined"
    >
      <STextInput
        v-if="isLocationSearchEnabled"
        v-model="zipCode"
        autocomplete="postal-code"
        class="s-product-search__field"
        :label="tr('client.homepage.product_search_zip_code_label')"
        name="zip_code"
        :placeholder="tr('client.homepage.zip_code_placeholder')"
        :rules="[zipcodeRule(locale)]"
        :show-valid-state="false"
        :validation-events="onCreatedIfValue(eager)"
      />
    </ProductSearch>
  </div>
</template>

<script setup lang="ts">
import { getAbTestFeature } from "@solvari/ab-testing";
import {
  eager,
  onCreatedIfValue,
  zipcodeRule,
} from "@solvari/common-fe/validation";
import { ProductSearch, STextInput } from "@solvari/components";
import { useI18nMainSiteHomepage } from "@solvari/translations";

import { useLocationSearchTarget } from "~/features/homepage/composables/useLocationSearchTarget";
import { useHostLocale } from "~/shared/composables/useHost";

const { tr } = useI18nMainSiteHomepage();
const locale = useHostLocale();
const isLocationSearchEnabled = getAbTestFeature<boolean>(
  "main-site-homepage-location-search",
  false,
);
const { zipCode, resolveTarget } = useLocationSearchTarget();
</script>

<style lang="postcss">
.s-homepage__product-search {
  @apply pt-6;
}

@screen 600 {
  .s-homepage__product-search {
    .s-product-search {
      @apply mx-auto max-w-screen-600;
    }
  }
}

@screen 800 {
  .s-homepage__product-search .s-product-search--with-fields {
    @apply max-w-screen-700;
  }
}
</style>
